export const linksConfig = {
  affonso: "https://backlinkgpt.affonso.io",
  whatsapp: "https://wa.me/+4915679400832",
  calIntro: "https://cal.com/felix-vemmer/30-minute-google-hangout-chat?duration=10",
  calEnterprise: "https://go.felixvemmer.com/cal",
  discord: "https://discord.gg/47mTz77PvX",
  twitter: "https://x.com/BacklinkGPT",
  instagram: "https://www.instagram.com/felixvemmer",
  linkedin: "https://www.linkedin.com/company/102403184",
  youtube: "https://www.youtube.com/@felixvemmer",
  tiktok: "https://www.tiktok.com/@felixvemmer",
} as const

export type TLinksConfig = typeof linksConfig
